import { Inject, Component, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDialog } from "@angular/material/dialog";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Observable } from "rxjs";
import swal from "sweetalert2";

import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { ReportService } from "../../../services/report.service";
import { UserService } from "../../../services/user.service";
import Swal from "sweetalert2";

import { DinamicData, Cell } from "../../../models/dinamic-data";

import { formatDate } from "@angular/common";

import { Methods } from "../../../shared/methods";
declare const $: any;
@Component({
  selector: "app-remove-hard-drives",
  templateUrl: "./remove-hard-drives.component.html",
  styleUrls: ["./remove-hard-drives.component.css"],
  providers: [ReportService],
})
export class RemoveHardDrivesComponent implements OnInit {
  public mtds: Methods = new Methods();

  public loading: boolean = false;

  //Identidad del usuario
  public identity;
  public token;

  //public saving = false;

  public bulk: Array<number> = [];

  public multipleData: DinamicData = new DinamicData([
    "check",
    "Manufacturer",
    "Model",
    "Serial Number",
    "Status",
  ]);

  /*DISCOS DUROS RECIBIDOS PARA INTEGRAR A LA TABLA*/
  public diskDrivers;

  /*PHYSICALDESTRUCTION REPORT*/
  public po;
  public clientsname;
  public arrayDiscs: any[] = [];
  public reportId;
  public typeReport;
  public filtros = [null,
    {
      key: "manufacturer",
      title: "Manufacturer",
      value: "",
      type: "contains",
      key_type: "manufacturer_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "model",
      title: "Model",
      value: "",
      type: "contains",
      key_type: "model_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "serialNumber",
      title: "Serial Number",
      value: "",
      type: "contains",
      key_type: "serialNumber_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },
    {
      key: "status",
      title: "Status",
      value: "",
      type: "contains",
      key_type: "status_type",
      type_options: [
        { value: "nofilter", name: "No Filter" },
        { value: "contains", name: "Contains" },
        { value: "startswith", name: "Starts With" },
        { value: "endswith", name: "Ends With" },
        { value: "equalto", name: "Equal To" },
        { value: "notcontain", name: "Does Not Contain" },
      ],
    },];
  public page = 1;
  public totalItems = 0;
  public totalPaginas = 1;
  public paginaActual = 1;
  public itemsPorPagina = "10";
  public statusRemoveHardDrive = null;

  public idattribute;
  public typed;
  constructor(
    public dialogRef: MatDialogRef<RemoveHardDrivesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _router: Router,
    public dialog: MatDialog,
    private _service: PrincipalinventoryService,
    private _reportService: ReportService,
    private _userService: UserService
  ) {
    this.token = this._userService.getToken();
    this.identity = this._userService.getIdentity();
    this.diskDrivers = data.diskdrives;
    this.po = data.po;
    this.clientsname = data.clientsname;
    this.idattribute = data.idatt;
    this.typed = data.type

  }

  ngOnInit() {
    this.List();
  }

  close() {
    this.dialogRef.close();
  }

  checkBulk(param) {
    /*console.log(this.multipleData.rows[1][0].grayed);
    console.log(this.multipleData.rows[1][4].value);
    this.multipleData.rows[1][4].value = 'DESTROYED';
    console.log(this.multipleData.rows[1][4].value);
    this.multipleData.rows[1][0].grayed = true;*/

    if (this.bulk.length === 0) {
      this.statusRemoveHardDrive = null;

      for (let d of this.multipleData.rows) {
        if (d[4].value !== "DESTROYED") d[0].grayed = false;
      }
    }

    if (this.bulk.length === 1) {
      const disk = this.multipleData.rows.find(
        (element) => element[0].value == param.value
      );

      this.statusRemoveHardDrive = disk[4].value;

      for (let d of this.multipleData.rows) {
        if (d[4].value !== this.statusRemoveHardDrive) d[0].grayed = true;
      }
    }
  }

  openModalRemove() {
    const result = this.diskDrivers.find(
      ({ recid }) => recid === Number(this.bulk[0])
    );

    if (
      result.hddErasureresults === "PARTIAL" ||
      result.hddErasureresults === "FAILED"
    )
      ($("#modalPartial") as any).modal("show");
    //$('#modalRemove').modal('show');
    else
      Swal.fire({
        title: "Are these drives going to be destroyed?",
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          cancelButton: "gts-btn-primary-outline",
          confirmButton: "gts-btn-primary",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        icon: "warning",
      }).then((result) => {
        if (result.isConfirmed) {
          this.removeHardDrives(1);
        } else {
          this.removeHardDrives(0);
        }
      });
    ($("#modalRemove") as any).modal("show");
  }

  openModalReturn() {
    Swal.fire({
      title: "Are you sure you want to return these drives back to the device?",
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        cancelButton: "gts-btn-primary-outline",
        confirmButton: "gts-btn-primary",
      },
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      icon: "warning",
    }).then((result) => {
      if (result.isConfirmed) {
        this.returnStatus();
      }
    });
    //$('#modalRemove').modal('show');
    // ($("#modalReturn") as any).modal("show");
  }

  removeHardDrives(action) {
    ($("#modalRemove") as any).modal("hide");
    ($("#modalPartial") as any).modal("hide");

    let json = {
      destroyed: action,
      bulk: this.bulk,
    };

    /*if(action === 1)
      this.openModalCheckReport();*/

    this._service.removeHardDrives(json).subscribe(
      (response) => {
        if (response.status === "success") {
          if (action !== 1) {
            this.showSwal(
              "success",
              "Removed!",
              "Hard drive has been removed successfully"
            );
            this.dialogRef.close();
          }

          if (action === 1) this.checkReport();
          //this.openModalCheckReport();
        } else {
          this.showSwal("error", "ERROR!", response.msg);
        }
      },
      (error) => {
        console.log("error");
      }
    );
  }

  /*openModalCheckReport() {
    
    ($('#modalCheckReport') as any).modal('show');
  }*/

  checkReport() {
    //($('#modalCheckReport') as any).modal('hide');

    /*var typeReport;

    if(type === 'basic')
      typeReport = 'PDTEMP';
    else
      typeReport = 'DETAILEDPHYSICALDESTRUCTION';*/

    let json = {
      //type: typeReport,
      po: this.po,
    };

    this._reportService.checkPOReport(this.token, json).subscribe(
      (response) => {
        this.typeReport = response.typeReport;

        if (response.status === "success") {
          //OBTENGO EL ID DEL REPORTE
          this.reportId = response.data.id;

          //GUARDO LOS DISCOS
          this.saveDisk();

          // SI ESTÁ COMPLETADO MANDO LLAMAR EL REPORT UPDATE PARA LA NOTIFICACIÓN
          if (response.data.completed === 1) this.reportUpdate();
        } else {
          this.saveDestructionReport();
        }
      },
      (error) => {
        console.log("error");
      }
    );
  }

  reportUpdate() {
    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    //let type = 'PDTEMP';

    let dataEnviar = {
      user_id: this.identity.sub,
      po: this.po,
      name: fechaHoy,
      //"type": type === 'detail' ? "DETAILEDPHYSICALDESTRUCTION" : "PHYSICALDESTRUCTION",
      type: this.typeReport,
      data: "",
    };

    this._reportService.update(this.token, this.reportId, dataEnviar).subscribe(
      (response) => {
        if (response.status == "success") {
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  saveDestructionReport() {
    let fechaHoy = formatDate(new Date(), "MM/dd/yyyy", "en");
    //let type = 'PDTEMP';

    let dataEnviar = {
      user_id: this.identity.sub,
      po: this.po,
      name: fechaHoy,
      type:
        this.typeReport === "DETAILEDPHYSICALDESTRUCTION"
          ? "DETAILEDPHYSICALDESTRUCTION"
          : "PDTEMP",
      //type: this.typeReport,
      data: null,
    };

    this._reportService.new(this.token, dataEnviar).subscribe(
      (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          this.reportId = response.data.id;
          this.saveDisk();
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  saveDisk() {
    let disk;

    for (disk of this.bulk) {
      const result = this.diskDrivers.find(
        ({ recid }) => recid === Number(disk)
      );

      let idrandom = Math.floor(Math.random() * 100 + 1);
      let serialnumberenviar = result.hddSerialnumber;
      let erasuredateneviar = this.getFecha();

      let json: any = {
        id: idrandom,
        SerialNumber: serialnumberenviar,
        ErasureEndDate: erasuredateneviar,
        clientsname: this.clientsname,
      };

      if (this.typeReport === "DETAILEDPHYSICALDESTRUCTION") {
        json = {
          id: idrandom,
          make: result.hddManufacturer,
          model: result.hddModel,
          capacity: result.hddCapacity,
          SerialNumber: serialnumberenviar,
          ErasureEndDate: erasuredateneviar,
          clientsname: this.clientsname,
        };
      }

      this.arrayDiscs.push(json);
    }

    this._reportService
      .enviarDiscoBulk(this.token, this.reportId, this.arrayDiscs)
      .subscribe(
        (response) => {
          console.log(response);
          if (
            response.code === 400 &&
            response.msg === "Authorization not valid"
          ) {
            this.mtds.notifyError("Your session has expired");
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          } else if (response.status === "success") {
            //REVISAR SI HAY DISCOS QUE YA ESTÁN EN EL REPORTE

            let serialNumberRepeated: string =
              "Hard drive has been removed and destroyed successfully \n";

            if (response.data !== "success") {
              serialNumberRepeated =
                serialNumberRepeated +
                "Serial number already exists on the report: \n";

              for (let sn of response.data) {
                serialNumberRepeated = serialNumberRepeated + sn + ", ";
              }

              serialNumberRepeated = serialNumberRepeated.slice(0, -2);

              this.showSwal("success", "Destroyed!", serialNumberRepeated);
            } else {
              this.showSwal(
                "success",
                "Destroyed!",
                "Hard drive has been destroyed successfully"
              );
            }

            this.dialogRef.close();
          } else {
            this.mtds.notifyError(response.msg, response.code);
          }
        },
        (error) => {
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
  }

  /*returnDiks(){

    let disk;

    for (disk of this.bulk) {
      
      const result = this.diskDrivers.find(({ recid }) => recid === disk);

      this.arrayDiscs.push(result.hddSerialnumber);

      if(result.reportId !== null)
        this.reportId = result.reportId;

    }

    this._reportService.borrarDiscoBulk(this.token, this.reportId, this.arrayDiscs).subscribe(
      response => {
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
                    
           this.checkIDReport();

        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        
      }, error => {
        this.mtds.notifyError(error.statusText, error.status);
        
      }
    );
  }

  checkIDReport(){

    let json = {
      report_id: this.reportId
    }  

    this._reportService.checkPOReport(this.token, json).subscribe(
      response => {        

        if(response.status === 'success'){

          // SI ESTÁ COMPLETADO MANDO LLAMAR EL REPORT UPDATE PARA LA NOTIFICACIÓN
          if(response.data.completed === 1){

            this.reportUpdate();
          }

        }

      }, error => {
        console.log("error");
      }

    );
  }*/

  returnStatus() {
    ($("#modalReturn") as any).modal("hide");

    let json = {
      bulk: this.bulk,
    };

    this._service.returnStatusHardDrives(json).subscribe(
      (response) => {
        console.log(response);

        if (response.status === "success") {
          this.showSwal(
            "success",
            "Returned!",
            "Hard drive has been returned to the device"
          );

          //this.returnDiks();

          this.dialogRef.close();
        } else {
          this.showSwal("error", "ERROR!", response.msg);
        }
      },
      (error) => {
        console.log("error");
      }
    );
  }

  getData() {
    console.log("disk", this.diskDrivers);
    this.filtros = [
      null,
      {
        key: "manufacturer",
        title: "Manufacturer",
        value: "",
        type: "contains",
        key_type: "manufacturer_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "model",
        title: "Model",
        value: "",
        type: "contains",
        key_type: "model_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "serialNumber",
        title: "Serial Number",
        value: "",
        type: "contains",
        key_type: "serialNumber_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
      {
        key: "status",
        title: "Status",
        value: "",
        type: "contains",
        key_type: "status_type",
        type_options: [
          { value: "nofilter", name: "No Filter" },
          { value: "contains", name: "Contains" },
          { value: "startswith", name: "Starts With" },
          { value: "endswith", name: "Ends With" },
          { value: "equalto", name: "Equal To" },
          { value: "notcontain", name: "Does Not Contain" },
        ],
      },
    ];
    this.diskDrivers.forEach(
      function (element) {
        let color;
        let grayed: boolean = false;

        if (element.hddErasureresults === "PASSED") color = "green";
        if (element.hddErasureresults === "PARTIAL") color = "orange";
        if (element.hddErasureresults === "FAILED") color = "red";
        if (element.hddErasureresults === "DESTROYED") {
          color = "red";
          grayed = true;
        }
        if (element.hddErasureresults === "REMOVED") color = "red";

        this.multipleData.rows.push([
          new Cell(element.recid, { type: "checkbox", grayed }),
          new Cell(element.hddManufacturer),
          new Cell(element.hddModel),
          new Cell(element.hddSerialnumber),
          new Cell(element.hddErasureresults, { class: "fw-bold", color }),
        ]);
      }.bind(this)
    );
  }

  List( e = null ){
    this.loading = true;
    let payload = {id:this.idattribute,type:this.typed,sort:this.filterrigh, order:this.sortStates }
    this._service.listHDDremove(e !== null ? e.page : 1,
      e !== null ? e.perPage : 10,payload,this.filtros).subscribe(
      (response) => {
        if (response.status === "success") {
          this.paginaActual = Number(response.page_actual);
          this.itemsPorPagina = String(response.items_per_page);
          this.totalItems = Number(response.total_items_count);
          this.totalPaginas = Number(response.total_pages);
          this.multipleData.rows = [];
          for (const element of response.data) {
            let color;
            let grayed: boolean = false;
    
            if (element.hddErasureresults === "PASSED") color = "green";
            if (element.hddErasureresults === "PARTIAL") color = "orange";
            if (element.hddErasureresults === "FAILED") color = "red";
            if (element.hddErasureresults === "DESTROYED") {
              color = "red";
              grayed = true;
            }
            if (element.hddErasureresults === "REMOVED") color = "red";
    
            this.multipleData.rows.push([
              new Cell(element.recid, { type: "checkbox", grayed }),
              new Cell(element.hddManufacturer),
              new Cell(element.hddModel),
              new Cell(element.hddSerialnumber),
              new Cell(element.hddErasureresults, { class: "fw-bold", color }),
            ]);       

          
          }
        }
        
        this.loading = false;
      });
  }
  public filterrigh = "";
  public sortStates = ""; 
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;
    this.List();
  }

  getFecha() {
    var fecha = new Date();

    let currentHours = fecha.getHours();
    let currentHoursText = ("0" + currentHours).slice(-2);
    let currentMinutes = fecha.getMinutes();
    let currentMinutesText = ("0" + currentMinutes).slice(-2);
    let currentSeconds = fecha.getSeconds();
    let currentSecondsText = ("0" + currentSeconds).slice(-2);

    let dia;
    dia = fecha.getDate();
    let day;
    if (dia < 10) {
      day = "0" + dia;
    } else {
      day = dia;
    }
    let mes;
    mes = fecha.getMonth() + 1;
    let month;
    if (mes < 10) {
      month = "0" + mes;
    } else {
      month = mes;
    }
    const anio = fecha.getFullYear();

    const hour = fecha.getTime();

    //console.log(month + '/' + day + '/' + anio + ' ' + currentHoursText + ':' + currentMinutesText + ':' + currentSecondsText);
    return (
      month +
      "/" +
      day +
      "/" +
      anio +
      " " +
      currentHoursText +
      ":" +
      currentMinutesText +
      ":" +
      currentSecondsText
    );
  }

  showSwal(type, title = "", message = "") {
    if (type === "success") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    } else if (type === "error") {
      swal.fire({
        title: title,
        text: message,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
  }
}
